<template>
  <div>
    <header class="navbar navbar-light sticky-top flex-md-nowrap p-0 navbar-expand-lg">
      <Link class="navbar-brand col-md-3 col-lg-2 me-0 px-3 pt-1 pb-1" href="/">
        <LogoDia class="fill-white" width="200" height="45" />
      </Link>
      <button class="navbar-toggler position-absolute d-md-none collapsed" type="button" aria-controls="sidebarMenu" aria-expanded="false" aria-label="Toggle navigation" @click="(navbar = !navbar)">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="navbar-nav w-100 align-items-center justify-content-between">
        <div class="px-3">Agency: {{ auth.user.agency.name }}</div>
        <div class="nav-item text-nowrap dropdown">
          <a class="nav-link dropdown-toggle" @click="(show = !show)" role="button" aria-expanded="false" :class="show ? 'show' : ''">
            <span>{{ auth.user.first_name }}</span>
            <span>&nbsp;{{ auth.user.last_name }}</span>
          </a>
          <ul class="dropdown-menu" :class="show ? 'show' : ''">
            <li @click="(show = false)">
              <Link class="dropdown-item" :href="`/profile`">My Profile</Link>
            </li>
            <li @click="(show = false)">
              <Link class="dropdown-item" href="/logout">Logout</Link>
            </li>
          </ul>
        </div>
      </div>
    </header>

    <div class="container-fluid">
      <div class="row">
        <nav id="sidebarMenu" class="col-md-3 col-lg-2 d-md-block sidebar collapse" :class="navbar ? 'show' : ''">
          <div class="position-sticky pt-3 sidebar-sticky">
            <main-menu />
          </div>
        </nav>

        <main class="main-container col-md-9 ms-sm-auto col-lg-10 px-md-4 py-md-3" scroll-region>
          <flash-messages />
          <slot />
        </main>

      </div>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import LogoDia from '@/Shared/LogoDia'
import Dropdown from '@/Shared/Dropdown'
import MainMenu from '@/Shared/MainMenu'
import FlashMessages from '@/Shared/FlashMessages'

export default {
  components: {
    Dropdown,
    FlashMessages,
    Icon,
    Link,
    LogoDia,
    MainMenu,
  },
  data() {
    return {
      show: false,
      navbar: false
    }
  },
  props: {
    auth: Object,
  },
}
</script>
